__turbopack_context__.v({
  "pearl": "website-pearl-button-module__wcFW8a__pearl",
  "pearl-border": "website-pearl-button-module__wcFW8a__pearl-border",
  "pearl-sheen": "website-pearl-button-module__wcFW8a__pearl-sheen",
  "quiet": "website-pearl-button-module__wcFW8a__quiet",
});
